
import React, { useContext, Children, useState, useEffect } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from 'react-router-dom'
import Button from '../formfields/Button'
import Spinner from '../ui-elements/Spinner'
import BarCodeReader from '../ui-elements/BarCodeReader'
import { useActivityBroadcast } from '../context/activity/ActivityBroadcastContext'



type Props = {
  setQuestionAnswer: any
  defaultValue: null | string | string[]
  barcodeOptions?: { formats?: Record<string, boolean>, showTarget?: boolean }
}

function QuestionBarCode({
  setQuestionAnswer,
  defaultValue,
  barcodeOptions
}: Props) {

  const {
    tableData
  } = useContext(GlobalContext)

  const [results, setResults] = useState<ScanResult | null>(null)
  const { broadcast } = useActivityBroadcast()

  useEffect(() => {
    broadcast('isScanningQRCode')
    return () => broadcast('noLongerScanningQRCode')
  }, [])

  useEffect(() => {
    if (results) {
      setQuestionAnswer(results.text)
    } else {
      setQuestionAnswer(null)
    }
  }, [results])

  return <div className={`w-full`}>


    <BarCodeReader
      results={results}
      setResults={setResults}
      barcodeOptions={barcodeOptions}
     />
 
  </div>
}
export default QuestionBarCode